import { Popup, Icon, List } from "semantic-ui-react";
import { CheckIcon, WarningIcon } from "../index";

const styles = {
	errorPopup: {},
};

const DepositTab = ({ t, disabled, deposit, depositErrors }) => {
	return (
		<Popup
			position="bottom right"
			disabled={disabled || depositErrors.length === 0}
			style={styles.errorPopup}
			offset="7px, 0"
			trigger={
				<span>
					<Icon name="medkit" size="small" /> {t("subMenu.deposit")}
					{!disabled && deposit && (depositErrors.length === 0 ? <CheckIcon /> : <WarningIcon />)}
				</span>
			}
		>
			<Popup.Header>{t("subMenu.depositMissingInformation")}</Popup.Header>
			<Popup.Content>
				{depositErrors.length > 0 && (
					<List bulleted>
						{depositErrors.map((error, index) => (
							<List.Item key={`depositError-${index}`}>{error}</List.Item>
						))}
					</List>
				)}
			</Popup.Content>
		</Popup>
	);
};

export default DepositTab;
